<template>
  <v-dialog v-model="show" :max-width="options.maxWidth" :transition="transition" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable>
    <v-card >

      <v-toolbar flat dark color="primary">
        
        <v-toolbar-title>Resend Request</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
      <v-text-field @change="recipientUpdated = true" v-model="faxInput" outline label="Fax Number">
      </v-text-field>
      <v-text-field @change="recipientUpdated = true" v-model="emailInput" outline label="Email">
      </v-text-field>
      Note: requests will be sent by email if the email field is populated. If no email is supplied, the request will be sent by fax.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!faxInput && !emailInput" @click="resendRequest" color="primary">Resend</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.card > .card__actions {
  flex: none;
}

.card__actions .btn {
  text-transform: capitalize;
}

.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.standardCard {
  border: 1px solid #e6e6e8;
  background-color: white;
}

.title {
  font-size: 24px;
  font-weight: 300;
  line-height: 1.33;
  text-align: center;
  color: white;
}

.content {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  text-align: center;
  color: #52535f;
}
.input {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 8px 16px;
  width: 100%;
  border-radius: 4px;
  font-size: 18px;
  background: white;
}
</style>

<script>
import ProviderCard from '@/components/cards/ProviderCard'
import DialogMixin from '@/core/mixins/DialogMixin'
import { mapActions } from 'vuex'
import bus from '@/core/helpers/bus'

export default {
  name: 'OneProviderInfoDialog',
  mixins: [DialogMixin],
  components: {
    ProviderCard
  },
  data() {
    return {
      faxInput: null,
      emailInput: null,
      recipientUpdated: false
    }
  },
  computed: {
  },
  mounted() {
    this.$on('open', this.onOpen)
  },
  methods: {
    ...mapActions('admin', [
      'getPatientList',
      'getUserList',
      'getRequest',
      'getRequestProvider',
      'setStatus',
      'sendRequest',
      'getRequestOverrides',
      'submitRequestOverrides',
      'submitRequestNote',
      'getDocumentFiles',
      'updateFaxOrEmail'
    ]),
    resendRequest() {
      if (this.recipientUpdated) {
        this.updateFaxOrEmail({id: this.options.request.id, fax: this.faxInput, email: this.emailInput}).then((data) => {
          this.sendRequest({id: this.options.request.id}).then(() => {
            this.toast('success', 'Sending Request')
            this.close()
          })
            .catch(error => {
              this.toast('error', error)
              return error
            })
        })
          .catch(error => {
            this.toast('error', error)
            return error
          })
      } else {
        console.log('no info updated')
        this.sendRequest({id: this.options.request.id}).then(() => {
          this.toast('success', 'Sending Request')
          this.close()
        })
          .catch(error => {
            this.toast('error', error)
            return error
          })
      }
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    close() {
      this.cancel()
    },
    onOpen() {
      this.recipientUpdated = false
      if (this.options.request) {
        if (this.options.request.providerFaxOverride) {
          this.faxInput = this.options.request.providerFaxOverride
        } else {
          this.faxInput = null
        }
        if (this.options.request.providerEmailOverride) {
          this.emailInput = this.options.request.providerEmailOverride
        } else {
          this.emailInput = null
        }
      }
    }
  },
  watch: {
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/ResendRequestDialog.vue